import { useAccountStore } from '@/app/modules/account';
import type { Guard } from './interfaces';

// Attached to the `''` record, so it also runs for the tab children — only the bare path is redirected.
export const specialEventsEntryGuard: Guard = async (to) => {
  const store = useAccountStore();
  await store.fetch();

  if (store.isElephant || to.path.replace(/\/$/, '') !== '/special-events') {
    return true;
  }

  return { path: '/special-events/pending', query: to.query, hash: to.hash };
};
